<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="shipmentInspectVo.pkid > 0 ? '编辑' : '新建'"
      class="shipmentInspect-edit"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="shipmentInspectVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <div class="vm-separate">
        <el-form-item label="系统编号">
          <el-input v-model="shipmentInspectVo.billNo" placeholder="系统自动生成" disabled/>
        </el-form-item>
        <el-form-item label="登记人">
          <el-input v-model="shipmentInspectVo.creatorName" disabled/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="发货单">
          <el-input v-model="shipmentInspectVo.deliveryBillNo" placeholder="请扫描发货单!" clearable @keyup.enter.native.stop="getByDeliveryBillNo"/>
        </el-form-item>
        <el-form-item label="异常/不良描述">
          <el-input v-model="shipmentInspectVo.processDesc" type="textarea"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="客户名称">
          <el-input v-model="shipmentInspectVo.customerName" readonly placeholder="请输入" clearable>
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="$refs.selectCustomer.open()">
              选择
            </el-button>
          </el-input>
          <customer-select ref="selectCustomer" @select="selectCustomer"/>
        </el-form-item>
        <el-form-item label="供应商名称">
          <el-input v-model="shipmentInspectVo.supplierName" placeholder="请选择供应商">
            <el-button slot="append" icon="el-icon-search" @click="$refs.supplierSelect.open()"> 选择</el-button>
          </el-input>
          <supplier-select ref="supplierSelect" @select="supplierSelect"/>
        </el-form-item>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="检验数量">
            <el-input v-model="shipmentInspectVo.qualifiedQuantity"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="异常/不良数量">
            <el-input v-model="shipmentInspectVo.badQuantity"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="库存数量">
            <el-input v-model="shipmentInspectVo.stockQuantity"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否已质检：">
            <el-radio-group v-model="shipmentInspectVo.isInspection">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="检验结果：">
            <el-radio-group v-model="shipmentInspectVo.inspectionResult">
              <el-radio :label="true">OK</el-radio>
              <el-radio :label="false">NG</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="责任部门">
            <el-input v-model="shipmentInspectVo.responsibilityDepartment"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否处理：">
            <el-radio-group v-model="shipmentInspectVo.needHandle">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="区域负责工程师：">
            <el-input v-model="shipmentInspectVo.regionalManager" placeholder="请选择" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectRegionalManager.open()"/>
            </el-input>
            <user-select ref="selectRegionalManager" @select="selectRegionalManager"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item v-if="shipmentInspectVo.needHandle" label="处理人：">
            <el-input v-model="shipmentInspectVo.handleName" placeholder="请选择" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectHandle.open()"/>
            </el-input>
            <user-select ref="selectHandle" @select="onSelectHandle"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="发货备注">
            <el-input v-model="shipmentInspectVo.deliveryNote" disabled type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="处理方式">
            <el-select v-model="shipmentInspectVo.handleWay">
              <el-option label="复检" value="复检"/>
              <el-option label="让步接收" value="让步接收"/>
              <el-option label="NCMR" value="NCMR"/>
              <el-option label="质量改进" value="质量改进"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title">配货明细</div>
      <el-table
          ref="table"
          :data="shipmentInspectVo.shipmentInspectMaterialDetails"
          border>
        <el-table-column
            prop="materialNo"
            align="center"
            label="物料编号"
            show-overflow-tooltip
            width="150"/>
        <el-table-column
            prop="mappingMaterialNo"
            align="center"
            label="旧物料编码"
            show-overflow-tooltip
            width="150"/>
        <el-table-column
            prop="specification"
            align="center"
            label="规格型号"
            show-overflow-tooltip/>
        <el-table-column
            prop="barcodeRecord"
            align="center"
            label="条码"
            show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.barcodeRecord" type="textarea" autosize placeholder="请输入条码"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="materialName"
            align="center"
            label="物料描述"
            show-overflow-tooltip/>
        <el-table-column prop="unit" align="center" label="单位" width="100"/>
        <el-table-column prop="quantity" align="center" label="数量" width="100"/>
        <el-table-column prop="salesOrderNote" align="center" label="商务备注" width="100"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            fixed="right"
            width="100px">
          <template slot-scope="scope">
            <el-button type="primary" @click="barCodeHandle(scope.row.barcodeRecord,scope.$index)">条码优化</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="title">性格能检查</div>
      <el-button type="success" plain style="margin-bottom:2px" @click="addProcess"> + 新增性能工序</el-button>
      <el-table :data="shipmentInspectVo.inspectionItems" border stripe>
        <el-table-column type="index" width="35" align="center"/>
        <el-table-column label="工序名称" width="130" prop="name" align="left">
          <template slot-scope="scope">
            <el-input v-if="scope.row.isAdded" v-model="scope.row.name" placeholder="请输入工序名称"/>
            <span v-else>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionStandard" label="检验标准" align="center" width="240">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.inspectionStandard"
                type="textarea"
                autosize
                placeholder="请输入工序名称"/>
          </template>
        </el-table-column>
        <el-table-column prop="approver" label="检验结果" align="center" width="250">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.approver">
              <el-radio :label="0">NG</el-radio>
              <el-radio :label="1">OK</el-radio>
              <el-radio :label="2">NA</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionMethod" label="检验方式" align="center" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.inspectionMethod">
              <el-option label="目测" :value="1"/>
              <el-option label="驱动器、电机、线材" :value="2"/>
              <el-option label="其他" :value="3"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionFrequency" label="检验频次" align="center" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.inspectionFrequency">
              <el-option label="每/单" :value="1"/>
              <el-option label="按照抽样方案GB2828-I" :value="2"/>
              <el-option label="其他" :value="3"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" align="center" width="240">
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请编辑工序备注"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="scope">
            <el-button type="danger" plain @click="shipmentInspectVo.inspectionItems.splice(scope.$index,1)">移除工序</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="title" style="margin-top:5px">包装检查</div>
      <el-button type="success" plain style="margin-bottom:2px" @click="addProcess2"> + 新增包装工序</el-button>
      <el-table :data="shipmentInspectVo.inspectionItemsBZ" border stripe>
        <el-table-column type="index" width="35" align="center"/>
        <el-table-column label="工序名称" width="140" prop="name" align="left">
          <template slot-scope="scope">
            <el-input v-if="scope.row.isAdded" v-model="scope.row.name" placeholder="请输入工序名称"/>
            <span v-else>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionStandard" label="检验标准" align="center" width="240">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.inspectionStandard"
                type="textarea"
                autosize
                placeholder="请输入工序名称"/>
          </template>
        </el-table-column>
        <el-table-column prop="approver" label="检验结果" align="center" width="250">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.approver">
              <el-radio :label="0">NG</el-radio>
              <el-radio :label="1">OK</el-radio>
              <el-radio :label="2">NA</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionMethod" label="检验方式" align="center" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.inspectionMethod">
              <el-option label="目测" :value="1"/>
              <el-option label="驱动器、电机、线材" :value="2"/>
              <el-option label="其他" :value="3"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionFrequency" label="检验频次" align="center" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.inspectionFrequency">
              <el-option label="每/单" :value="1"/>
              <el-option label="按照抽样方案GB2828-I" :value="2"/>
              <el-option label="其他" :value="3"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" align="center" width="240">
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" type="textarea" autosize placeholder="请编辑工序备注"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="scope">
            <el-button type="danger" plain @click="shipmentInspectVo.inspectionItemsBZ.splice(scope.$index,1)">移除工序</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          订单附件
        </div>
        <div
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="shipmentInspectVo.attachments"
            ref="payData1"
            :data="shipmentInspectVo.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import UploadFile from "@/components/UploadFile";
  import SupplierSelect from "@/views/information/SupplierManage/SupplierSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";

  export default {
    name: "ShipmentInspectEdit",
    components: {CustomerSelect, UserSelect, SupplierSelect, UploadFile},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        saveLoading: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        shipmentInspectVo: {
          pkid: "",
          billNo: "",
          creatTime: "",
          creatorName: loginUtil.getName(),
          supplierName: "",
          customerName: "",
          customerId: "",
          supplierId: "",
          supplierCode: "",
          processNode: "",
          processDesc: "",
          materialNo: "",
          materialName: "",
          quantity: "",
          isInspection: false,
          inspectionResult: true,
          needHandle: true,
          qualifiedQuantity: "",
          badQuantity: "",
          stockQuantity: "",
          responsibilityDepartment: "",
          handleName: "",
          regionalID: "",
          handleID: "",
          handleWay: "",
          deliveryBillNo: "",
          deliveryNote: "",
          barcodeRecord: "",
          regionalManager: "",
          attachments: [],
          inspectionItems: [],
          inspectionItemsBZ: [],
          shipmentInspectMaterialDetails: [],
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.shipmentInspectVo.pkid = row.pkid;
          if (this.shipmentInspectVo.pkid > 0) {
            this.getData();
          }
        }else {
          //性能检验
          this.getProcess1(5);
          //包装检验
          this.getProcess2(8);
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `shipmentInspects/${this.shipmentInspectVo.pkid}`)
          .then(resp => {
            this.shipmentInspectVo = resp.data;
            this.shipmentInspectVo.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });
            });
            this.contentLoading = false;
          }).catch(() => {
            this.contentLoading = false;
          });
      },
      barCodeHandle(barcode,index) {
        if (barcode && barcode.includes("-")) {
          const serialSet = new Set();
          const lines = barcode.split(/\r?\n/);
          for (let line of lines) {
            line = line.trim();
            if (line === "") continue;
            const parts = line.split("-");
            if (parts.length >= 1) {
              const candidate = parts[1].trim();
              serialSet.add(candidate);
            }
          }
          const serialArray = Array.from(serialSet);
          this.shipmentInspectVo.shipmentInspectMaterialDetails[index].barcodeRecord = serialArray.join("\n");

        }
      },
      getByDeliveryBillNo() {
        if (this.shipmentInspectVo.deliveryBillNo) {
          this.$http
            .get("basic", `sapDeliveryBills/getModelInfoByDeliveryBillNo/${this.shipmentInspectVo.deliveryBillNo}`)
            .then((res) => {
              if (res.success) {
                let model = {};
                model = Object.assign(model, res.data);
                this.shipmentInspectVo.shipmentInspectMaterialDetails = model.detailAppVOS;
                this.shipmentInspectVo.customerName = model.purchaseUnit;
                this.shipmentInspectVo.customerNo = model.customerNo;
                this.shipmentInspectVo.customerId = model.customerId;
                this.shipmentInspectVo.deliveryNote = model.deliveryNote1;
                console.log(model);
              }
            })
            .catch(() => {
              this.contentLoading = false;
            });
        }
      },
      selectRegionalManager(row) {
        this.shipmentInspectVo.regionalID = row.systemUserID;
        this.shipmentInspectVo.regionalManager = row.employeeName;
      },
      onSelectHandle(row) {
        this.shipmentInspectVo.handleID = row.systemUserID;
        this.shipmentInspectVo.handleName = row.employeeName;
      },
      getProcess1(type) {
        this.contentLoading = true;
        this.$http.get("basic",`inspectionTemplates/getProcessTemplate/${type}`).then((res)=>{
          this.shipmentInspectVo.inspectionItems = res.data;
          this.shipmentInspectVo.inspectionItems.forEach(item => {
            item.approver = 1;
          });
          this.contentLoading = false;
        }).catch(() => {
          this.contentLoading = false;
        });
      },
      getProcess2(type) {
        this.contentLoading = true;
        this.$http.get("basic",`inspectionTemplates/getProcessTemplate/${type}`).then((res)=>{
          this.shipmentInspectVo.inspectionItemsBZ = res.data;
          this.shipmentInspectVo.inspectionItemsBZ.forEach(item => {
            item.approver = 1;
          });
          this.contentLoading = false;
        }).catch(() => {
          this.contentLoading = false;
        });
      },
      addProcess() {
        let process = {
          name:"",
          approver:0,
          inspectionStandard:"",
          inspectionFrequency:"",
          inspectionMethod:"",
          note:"",
          isAdded:true,
        };
        this.shipmentInspectVo.inspectionItems.push(process);
      },
      addProcess2() {
        let process = {
          name:"",
          approver:0,
          inspectionStandard:"",
          inspectionFrequency:"",
          inspectionMethod:"",
          note:"",
          isAdded:true,
        };
        this.shipmentInspectVo.inspectionItemsBZ.push(process);
      },
      fileDelete(index) {
        this.shipmentInspectVo.attachments.splice(index, 1);
      },
      oneDelete(index) {
        this.shipmentInspectVo.details.splice(index, 1);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            imgUrl: "",
          };
          this.$http.get("basic", `files/getDownloadUrl?key=${params.filePath}`).then((res) => {
            if (res.success) {
              params.imgUrl = res.data;
              this.imgUrls.push(params.imgUrl);
            }
          });
          this.shipmentInspectVo.attachments.push(params);
        }
      },
      supplierSelect(row) {
        this.shipmentInspectVo.supplierName = row.name;
        this.shipmentInspectVo.supplierId = row.pkid;
        this.shipmentInspectVo.supplierCode = row.outerNO;
      },
      selectCustomer(row) {
        console.log(row);
        this.shipmentInspectVo.customerName = row.customerName;
        this.shipmentInspectVo.customerId = row.customerID;
        this.shipmentInspectVo.customerNo = row.customerNo;
      },
      materialSelect(row) {
        this.shipmentInspectVo.materialId = row.id;
        this.shipmentInspectVo.materialName = row.name;
        this.shipmentInspectVo.materialNo = row.no;
        this.shipmentInspectVo.mappingMaterialNo = row.mappingMaterialNo;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.shipmentInspectVo.pkid > 0) {
              this.$http
                .put("basic", "shipmentInspects", this.shipmentInspectVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "shipmentInspects", this.shipmentInspectVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.title {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  color: #000;
}
::v-deep .el-dialog{
  top: 5% !important;
  left: 0 !important;
}
</style>